import React from 'react';
import styles from './TextArea.module.css';

const TextArea = ({ id, label, classes, ...props }) => {
	return (
		<div className='form-floating mb-3'>
			<textarea
				{...props}
				className={`form-control ${styles.textarea} ${classes && classes}`}
				placeholder=''
				id={id}></textarea>
			<label htmlFor={id} className={`${styles.label} fw-medium`}>
				{label}
			</label>
		</div>
	);
};

export default TextArea;
